export default __webpack_public_path__ + "static/img-nhs-kortical--mobile-f43413ad99fd93f823a15b168672a2bc.webp";